var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-tabs',[_c('b-tab',{attrs:{"title":"Normal Zone"}},[_c('zone-form',{attrs:{"is-new":true}})],1),_c('b-tab',{attrs:{"title":"Closed Zone"}},[_c('closed-zone-form')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }